import { RootState } from '@/plugins/store';
import { ReglementFournisseurState } from '@/modules/ReglementsFournisseurs/store/state';
import { ReglementDTO } from '@/models/ReglementDTO';
import { GetterTree } from 'vuex';

export const getters: GetterTree<ReglementFournisseurState, RootState> = {

    getReglements(state) : ReglementDTO[] | undefined {
        return state.reglements;
    },
    getHeader(state){
        return state.tableHeader;
    },
    getReglementSort(state) {
        return state.sort;
    },
    isLoading(state) {
        return state.isLoading;
    },
    getReglementPage(state) {
        return state.page;
    },
    getReglementNumberOfPage(state) {
        return state.numberOfPage;
    },
    getReglementCount(state) {
        return state.count;
    },
    isXlsLoading(state) : boolean {
        return state.isXlsLoading;
    }
};
